import { render } from "./PartenerFormComercial.vue?vue&type=template&id=d9390ab6&scoped=true&ts=true"
import script from "./PartenerFormComercial.vue?vue&type=script&lang=ts"
export * from "./PartenerFormComercial.vue?vue&type=script&lang=ts"

import "./PartenerFormComercial.vue?vue&type=style&index=0&id=d9390ab6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9390ab6"]])

export default __exports__